import GraphQLJSON from 'graphql-type-json';

const typeResolvers = {};

const resolvers = {
  JSON: GraphQLJSON,
};

const brandWiseWarehouseSkus = (globalOutletId, companyId, warehouseIds) => {
  if (companyId === '470041') {
    return {
      Result: true,
      Reason: '',
      Data: [
        {
          id: '2',
          name: 'Cadbury',
          pictureurl:
            'https://s3-ap-southeast-1.amazonaws.com/bizompictures/cadbury156031476543871560314765.png',
          skuData: [],
        },
        {
          id: '1',
          name: 'Good Knight',
          pictureurl:
            'https://s3-ap-southeast-1.amazonaws.com/bizompictures/good-knight-logo-min156031466245061560314662.png',
          skuData: [],
        },
      ],
    };
  } else if (companyId === '470042') {
    return {
      Result: true,
      Reason: '',
      Data: [
        {
          id: '2',
          name: 'Surf',
          pictureurl:
            'https://s3-ap-southeast-1.amazonaws.com/bizompictures/surf156031498364251560314983.png',
          skuData: [],
        },
        {
          id: '1',
          name: 'Britannia',
          pictureurl:
            'https://s3-ap-southeast-1.amazonaws.com/bizompictures/britannia156031492231571560314922.png',
          skuData: [],
        },
      ],
    };
  }

  return JSON.stringify({});
};

const getSuggestedOutlets = phoneno => {
  return [
    {
      globalId: '1',
      name: 'Outlet One',
      address: 'Bellendur',
      pincode: '560103',
      phoneno: '8296768643',
      ownerMobile: '8296768643',
    },
    {
      globalId: '2',
      name: 'Outlet Two',
      address: 'Kadubesanahalli',
      pincode: '560103',
      phoneno: '8296768643',
      ownerMobile: '8296768643',
    },
  ];
};

const getBanners = (globalOutletId, companyId, popId, warehouseIds) => {
  if (!popId) {
    if (companyId === '470041') {
      return [
        {
          id: '1',
          name: 'Offer Zone Mysore',
          type: 'Banner',
          popType: 'IMAGE',
          url:
            'https://s3-ap-southeast-1.amazonaws.com/bizompop/4731_716bde36Offer_Zone.png',
          seqNo: '0',
          pages: 'Skulist',
          levelId: '2',
          levelSpecificId: '2',
          levelName: 'ZONE',
          priority: 7,
          popPropertiesId: '2',
          popPropertyValueId:
            '3374,3,3399,245,2830,3929,3928,3927,73,3926,3925,3924,3923,3922,3921,3920,3919,3857,3856,3854,3850,3932,3931,246,3240,3399,3181,3179,192,3289,252,1560,620,1565,253,3884,3883,3874,3877,3906,3867,3852,3846,3845,2733,3918,4,3404,3212,2829,3378,3081,2500,2495,1040,1029,1024,2,1,589,590,631,630,607,606',
          propertyName: 'skunits',
          onClick: true,
        },
        {
          id: '2',
          name: 'Banner CLick',
          type: 'Banner',
          popType: 'IMAGE',
          url:
            'https://s3-ap-southeast-1.amazonaws.com/bizompop/4731_d4fc4552download.jpeg',
          seqNo: '3',
          pages: 'Collateral',
          levelId: '1',
          levelSpecificId: '473',
          levelName: 'COMPANY',
          priority: 8,
          popPropertiesId: '1',
          popPropertyValueId: '7',
          propertyName: 'collateral',
          onClick: true,
        },
      ];
    } else if (companyId === '470042') {
      return [
        {
          id: '3',
          name: 'Without click',
          type: 'Banner',
          popType: 'IMAGE',
          url:
            'https://s3-ap-southeast-1.amazonaws.com/bizompop/4731_52047bddMessi-Pepsi.png',
          seqNo: '4',
          pages: 'Collateral',
          levelId: '1',
          levelSpecificId: '473',
          levelName: 'COMPANY',
          priority: 8,
          popPropertiesId: '1',
          popPropertyValueId: '4',
          propertyName: 'collateral',
          onClick: true,
        },
        {
          id: '6',
          name: 'PDF Check',
          type: 'Banner',
          popType: 'IMAGE',
          url:
            'https://s3-ap-southeast-1.amazonaws.com/bizompop/4731_f15c0d65PDF_Dark_EN.png',
          seqNo: '5',
          pages: 'Collateral',
          levelId: '1',
          levelSpecificId: '473',
          levelName: 'COMPANY',
          priority: 8,
          popPropertiesId: '1',
          popPropertyValueId: '5',
          propertyName: 'collateral',
          onClick: true,
        },
      ];
    }
  } else if (popId === '4') {
    return [
      {
        id: '4',
        name: 'video',
        type: 'none',
        popType: 'VIDEO',
        url:
          'https://s3-ap-southeast-1.amazonaws.com/bizompop/4731_0cba5d4bLionel_Messi_and_Salah_new_Pepsi_ad_commercial__-_Behind_the_scene_making.mp4',
        seqNo: '23',
        pages: '',
        levelId: '1',
        levelName: 'COMPANY',
        levelSpecificId: '473',
        onClick: false,
        popPropertiesId: null,
        popPropertyValueId: null,
        priority: 8,
      },
    ];
  } else if (popId === '5') {
    return [
      {
        id: '5',
        name: 'pdf',
        type: 'none',
        popType: 'PDF',
        url:
          'https://s3-ap-southeast-1.amazonaws.com/bizompop/4731_9593bbf5Tracks_within_Engineering.pdf',
        seqNo: '25',
        pages: '',
        levelId: '1',
        levelName: 'COMPANY',
        levelSpecificId: '473',
        onClick: false,
        popPropertiesId: null,
        popPropertyValueId: null,
        priority: 8,
      },
    ];
  } else if (popId === '7') {
    return [
      {
        id: '7',
        name: 'Avengers',
        type: 'none',
        popType: 'IMAGE',
        url:
          'https://s3-ap-southeast-1.amazonaws.com/bizompop/4731_3628911bavengers-infinity-war-poster.jpg',
        seqNo: '27',
        pages: 'Skulist',
        levelId: '2',
        levelSpecificId: '2',
        levelName: 'ZONE',
        priority: 7,
        popPropertiesId: '2',
        popPropertyValueId:
          '3374,3,3399,245,2830,3929,3928,3927,73,3926,3925,3924,3923,3922,3921,3920,3919,3857,3856,3854,3850,3932,3931,246,3240,3399,3181,3179,192,3289,252,1560,620,1565,253,3884,3883,3874,3877,3906,3867,3852,3846,3845,2733,3918,4,3404,3212,2829,3378,3081,2500,2495,1040,1029,1024,2,1,589,590,631,630,607,606',
        propertyName: 'skunits',
        onClick: true,
      },
    ];
  }
};

const getSuggestedCompanies = globalOutletId => {
  return [
    {
      id: '470041',
      name: 'Brand One',
      kyc: [],
      logoUrl: 'https://www.ibef.org/uploads/industry/itc.jpg',
    },
    {
      id: '470042',
      name: 'Brand Two',
      kyc: [],
      logoUrl: 'https://www.ibef.org/uploads/industry/EMAMI.png',
    },
    {
      id: '470043',
      name: 'Brand Three',
      kyc: [],
      logoUrl: 'https://www.ibef.org/uploads/industry/EMAMI.png',
    },
  ];
};

const addCompany = (globalOutletId, companyId, kyc) => {
  return {
    id: '1',
    globalOutletId: '1',
    name: 'OutLet One',
    status: 'ACTIVE',
    type: 'PRIMARY',
    mappedCompanies: [
      {
        status: 'ACTIVE',
        company: {
          id: '470041',
          name: 'Brand One',
          kyc: [],
          logoUrl: 'https://www.ibef.org/uploads/industry/itc.jpg',
        },
      },
      {
        status: 'ACTIVE',
        company: {
          id: '470042',
          name: 'Brand Two',
          kyc: [],
          logoUrl: 'https://www.ibef.org/uploads/industry/EMAMI.png',
        },
      },
      {
        status: 'PENDING',
        company: {
          id: '470043',
          name: 'Brand Three',
          kyc: [],
          logoUrl: 'https://www.ibef.org/uploads/industry/EMAMI.png',
        },
      },
      {
        status: 'PENDING',
        company: {
          id: '470044',
          name: 'Brand Four',
          kyc: [],
          logoUrl: 'https://www.ibef.org/uploads/industry/EMAMI.png',
        },
      },
    ],
  };
};

const mocks = {
  Query: {
    brandWiseWarehouseSkus: (_, { globalOutletId, companyId, warehouseIds }) =>
      brandWiseWarehouseSkus(globalOutletId, companyId, warehouseIds),
    getSuggestedOutlets: (_, { phoneno }) => getSuggestedOutlets(phoneno),
    banners: (_, { globalOutletId, companyId, popId, warehouseIds }) =>
      getBanners(globalOutletId, companyId, popId, warehouseIds),
    suggestedCompanies: (_, { globalOutletId }) =>
      getSuggestedCompanies(globalOutletId),
  },
  Mutation: {
    associateCompany: (_, { globalOutletId, companyId, kyc }) =>
      addCompany(globalOutletId, companyId, kyc),
  },
};
export { resolvers, typeResolvers, mocks };
